let content_blocks = require('../contents');

export function init(){
    
    $('#edit_button_modal .btn.delete').on('click', function(){
        let modal = $(this).closest('.modal');
        let block_id = modal.find('[name="block_id"]').val();
        $('#'+block_id).remove();
        content_blocks.show_start_block();
        content_blocks.show_block_order();

        modal.modal('hide');

        modal.find('form')[0].reset();
    });

    $('#edit_button_modal').on('show.bs.modal', function (event) {
        let button = $(event.relatedTarget);
        let block = $(button).closest('.block');
        let modal = $(this);

        let text = block.attr('data-text')
        let title = block.attr('data-title')
        let url = block.attr('data-url')
        try {

            translations = JSON.parse(block.attr('data-translations'));
            if(typeof translations[window._content_selected_language] != 'undefined'){
                
                if(typeof translations[window._content_selected_language]['title'] != 'undefined'){
                    title = translations[window._content_selected_language]['title'];
                }

                if(typeof translations[window._content_selected_language]['url'] != 'undefined'){
                    url = translations[window._content_selected_language]['url'];
                }

                if(typeof translations[window._content_selected_language]['text'] != 'undefined'){
                    text = translations[window._content_selected_language]['text'];
                }

            }

        } catch(err){}

        modal.find('[name="block_id"]').val(block.attr('id'));
        modal.find('[name="classes"]').val(block.attr('data-class'));
        modal.find('[name="text"]').val(text);
        modal.find('[name="title"]').val(title);
        modal.find('[name="url"]').val(url);
        modal.find('[name="blank"]').prop('checked', block.attr('data-blank') == 'true' ? true : false);
        modal.find('[name="nofollow"]').prop('checked', block.attr('data-nofollow') == 'true' ? true : false);

        let select_visible = modal.find('[name="visible"]');
        if (block.attr('data-visible') != null || block.attr('data-visible') != 'undefined') {
            select_visible.find('option[value="'+ block.attr('data-visible')).prop('selected', true);
        } else {
            select_visible.find('option[value="visible"]').prop('selected', true);
        }
        
        select_visible.select2({
            minimumResultsForSearch: $(this).attr('minimumResultsForSearch') ?? 10,
            theme: 'bootstrap',
            width: 'resolve',
        });

        let select_link_type = modal.find('[name="link_type"]');
        if (block.attr('data-link-type') != null || block.attr('data-link-type') != 'undefined') {
            select_link_type.find('option[value="'+ block.attr('data-link-type')).prop('selected', true);
        } else {
            select_link_type.find('option[value="external_link"]').prop('selected', true);
        }
        
        select_link_type.select2({
            minimumResultsForSearch: $(this).attr('minimumResultsForSearch') ?? 10,
            theme: 'bootstrap',
            width: 'resolve',
        });

        let select_align = modal.find('[name="align"]');
        if (block.attr('data-align') != null || block.attr('data-align') != 'undefined') {
            select_align.find('option[value="'+ block.attr('data-align')).prop('selected', true);
        } else {
            select_align.find('option[value="center"]').prop('selected', true);
        }
        
        select_align.select2({
            minimumResultsForSearch: $(this).attr('minimumResultsForSearch') ?? 10,
            theme: 'bootstrap',
            width: 'resolve',
        });

        let select_style = modal.find('[name="style"]');
        if (block.attr('data-style') != null || block.attr('data-style') != 'undefined') {
            select_style.find('option[value="'+ block.attr('data-style')).prop('selected', true);
        } else {
            select_style.find('option[value="filled"]').prop('selected', true);
        }
        
        select_style.select2({
            minimumResultsForSearch: $(this).attr('minimumResultsForSearch') ?? 10,
            theme: 'bootstrap',
            width: 'resolve',
        });
    });

    $('#edit_button').on('submit', function (e) {
        e.preventDefault();
        let form = $(this);
        let url = form.find('[name="url"]').val();
        let link_type = form.find('[name="link_type"]').val();

        if (link_type != 'external_link') {
            let url_post = window._routes['microsites.contents.block.check_link_slug'].replace('{microsite}', window.microsite_id).replace('{content}', window.content_id);
    
            let form_data = new FormData();
            form_data.append('link_type', link_type);
            form_data.append('slug', url);
    
            window.forms.post(url_post, form_data, true, true)
                .then((response) => {
                    if (response.data == true) {
                        save_data_atributes(form);
                    } else {
                        window.messages.error(__('No existe el slug indicado'));
                    }
                })
                .catch((error) => {
                    console.log('ERROR', error);
                })
                .finally(() => {
                    window.blockui.release();
                });
        } else {
            save_data_atributes(form);
        }
        
    });

    $('.block[data-type="button"]').each(function() {
        content_blocks.create_visible_button_blocks($(this));
    })
}

function save_data_atributes(form) {

    let block = $('#'+ form.find('[name="block_id"]').val());
    let text = form.find('[name="text"]').val();
    let title = form.find('[name="title"]').val();
    let align = form.find('[name="align"]').val();
    let style = form.find('[name="style"]').val();
    let url = form.find('[name="url"]').val();
    let link_type = form.find('[name="link_type"]').val();

    if (link_type == 'external_link' && url != '') {
        url = url.replace(' ','');
        const patronMailtoTell = /^(mailto|tel):/;

        if (!patronMailtoTell.test(url)) {
            
            //url ha de empezar por http:// o https://
            const patronURL = /^(https?:\/\/)/;
            if (!patronURL.test(url)) {
                url = 'https://'+url;
            }
        }
    }

    let translations = [];
    if(window._content_languages.length > 1){

        try {
            translations = JSON.parse(block.attr('data-translations'));
        } catch(err){
            translations = [];
        }

        // preparo traducciones que no existan

        for(let _language of window._content_languages){
            if(typeof translations[_language] == 'undefined'){
                translations[_language] = { 'title': '', 'text': '', 'url': '' };
            }
        }

        // guardo tranduccion actual 

        translations[window._content_selected_language]['title'] = title;
        translations[window._content_selected_language]['text'] = text;
        translations[window._content_selected_language]['url'] = url;

        // si es idioma base

        if(window._content_selected_language == window._locale){

            block.attr('data-title', title);
            block.attr('data-text', text);
            block.attr('data-url', url);

            // actualizamos traducciones vacias

            for(let _language of window._content_languages){
                if(_language != window._locale){
                    if(translations[_language]['title'] == ''){
                        translations[_language]['title'] = title;
                    }
                    if(translations[_language]['text'] == ''){
                        translations[_language]['text'] = text;
                    }
                    if(translations[_language]['url'] == ''){
                        translations[_language]['url'] = url;
                    }
                }
            }
        }

        if (link_type != 'external_link' || block.attr('data-link-type') != link_type) {
            for(let _language of window._content_languages){
                translations[_language]['url'] = url;
            }
        }

    } else {
        block.attr('data-text', text);
        block.attr('data-title', title);
        block.attr('data-url', url);
    }

    block.attr('data-class', form.find('[name="classes"]').val());
    block.attr('data-visible', form.find('[name="visible"]').val());
    block.attr('data-url', url);
    block.attr('data-link-type', link_type);
    block.attr('data-align', align);
    block.attr('data-style', style);
    block.attr('data-blank', form.find('[name="blank"]').prop('checked'));
    block.attr('data-nofollow', form.find('[name="nofollow"]').prop('checked'));
    block.attr('data-translations', JSON.stringify(translations));

    let div = '<div class="row">'+
                '<div class="col d-flex justify-content-' + align + '">';

                switch (style) {
                    case 'filled':
                        div+='<a class="btn btn-info trans trans_button" data-toggle="modal" data-target="#edit_button_modal"> '+ text ?? window.__('Botón') + '</a>';
                        break;
                    case 'outline':
                        div+='<a class="btn btn-outline-info trans trans_button" data-toggle="modal" data-target="#edit_button_modal"> '+ text ?? window.__('Botón') + '</a>';
                        break;
                    case 'text':
                        div+='<a class="trans trans_button" data-toggle="modal" data-target="#edit_button_modal"> '+ text ?? window.__('Botón') + '</a>';
                        break;
                
                    default:
                        break;
                }
                div+='</div>'+
            '</div>';
    block.find('.card-body').html(div);
    content_blocks.change_visible_button_blocks(block);
    
    let modal = form.closest('.modal');
    modal.modal('hide');
}